// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"4d0885ac","227":"d65d8f2f","266":"c6d6745e","397":"5fc4fecb"}[chunkId] + ".chunk.js";
};